import { buildLoginUrl } from '@zorba-shared/core/Services/urlBuilderService';

export const getHeaderLings = (path) => [
  {
    title: 'Who We Serve',
    isDropdown: true,
    children: [
      {
        title: 'Asset Managers',
        href: '/',
        isActive: (pathname) => pathname == '/',
      },
      {
        title: 'Agents',
        href: '/agents',
        isActive: (pathname) => pathname == '/agents',
      },
      {
        title: 'Investors',
        href: '/investors',
        isActive: (pathname) => pathname == '/investors',
      },
    ],
    isActive: (pathname) => ['/', '/agents', '/investors'].filter(link => link === pathname),
  },
  {
    title: 'Our Company',
    isDropdown: true,
    children: [
      {
        title: 'About Us',
        href: '/about-us',
        isActive: (pathname) => pathname.includes('/about-us'),
      },
      {
        title: 'Contact Us',
        href: '/contact-us',
        isActive: (pathname) => pathname.includes('/contact-us'),
      },
    ],
    isActive: (pathname) => ['/about-us', '/contact-us'].includes(pathname),
  },  
  {
    title: 'Data',
    href: '/data',
    isActive: (pathname) => pathname == '/data',
  },
  {
    title: 'Institutional Tracker',
    href: '/institutional-tracker',
    isActive: (pathname) => pathname == '/institutional-tracker',
  },
  {
    title: 'Blog',
    href: 'https://blog.getzorba.com',
    isActive: (pathname) => false,
  },  
  {
    title: 'FAQ',
    href: '/faq',
    isActive: (pathname) => pathname.includes('/faq'),
  },

];
